import { useSelector } from "react-redux";
import { selectCurrencyCode } from "../store/store-list/StoreListSelectors";
import { CURRENCY_MAP } from "../utils/Constants";

/**
 * Symbol for a product price: the product's own currency when the adapter
 * returns one, otherwise the store currency, otherwise "$".
 */
export const useCurrencySymbol = (productCurrencyCode?: string): string => {
  const storeCurrencyCode = useSelector(selectCurrencyCode);
  const currencyCode = productCurrencyCode || storeCurrencyCode;
  return (CURRENCY_MAP as Record<string, string>)[currencyCode] ?? "$";
};
